import React from 'react';
import Pagination from '@amzn/meridian/pagination';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';

const defaultItemsPerPageOptions = [10, 20, 30] as const;

interface TablePaginationProps {
  currentPage: number;
  itemsPerPage: number;
  itemsPerPageOptions?: number[];
  pageCount: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  onPageChange: (page: number) => void;
}

export const TablePagination: React.FC<TablePaginationProps> = (props) => {
  const {
    currentPage,
    itemsPerPage,
    itemsPerPageOptions = defaultItemsPerPageOptions,
    pageCount,
    onItemsPerPageChange,
    onPageChange,
  } = props;

  return (
    <Row alignmentHorizontal="end">
      <Select
        data-testid="pagination-select"
        value={itemsPerPage}
        onChange={onItemsPerPageChange}
      >
        {itemsPerPageOptions.map((option) => (
          <SelectOption
            data-testid={`pagination-select-option-${option}`}
            key={option}
            label={`${option} Items`}
            value={option}
          />
        ))}
      </Select>
      <Pagination
        currentPage={currentPage}
        data-testid="pagination"
        numberOfPages={pageCount}
        onChange={onPageChange}
      />
    </Row>
  );
};
